import $ from "jquery";

$(window).on('resize', function () {
    if ($(window).width() <= 767) {
        $('main .wrapper aside .sidebar').prepend($('.main-content nav .dropdown')); // append -> object
    }
    else {
        // Back into its own slot beside the language selector. Appending to the
        // header row itself (nav .container) spreads logo / EN / My Account apart.
        $('main .wrapper .main-content nav .main-header-nav-all-cover').append($('main .wrapper aside .sidebar .dropdown')); // append -> object
    }
})

$(function () {
    if ($(window).width() <= 767) {
        $('main .wrapper aside .sidebar').prepend($('.main-content nav .dropdown')); // append -> object
    }
});